<div class="login-errors">
  @switch (status()) {
    @case (1) {
      <small class="error" i18n="@@login.error.unknown">Nobody knows</small>
    }

    @case (401) {
      @switch (message()) {
        @case ('error.login.wrong-credentials') {
          <small class="error" i18n="@@login.error.wrong-credentials">Wrong credentials</small>
        }

        @case ('error.login.incorrect-totp') {
          <small class="error" i18n="@@login.error.incorrect-totp">Incorrect One Time Password</small>
        }

        @case ('error.login.max-failed-attempts') {
          <small class="error" i18n="@@login.error.max-failed-attempts"
            >Your user account has been blocked, please contact your label manager.</small
          >
        }

        @case ('error.login.password-expired') {
          <small class="error" i18n="@@login.error.password-expired">Password must be updated! Redirecting....</small>
        }
      }
    }

    @case (403) {
      <small class="error" i18n="@@login.error.403">Access Denied</small>
    }

    @case (500) {
      <small class="error" i18n="@@login.error.500">Bad Gateway</small>
    }
  }
</div>
